<div class="container">
  <div class="auth">
    <div class="form border-radius">
      <div class="form__block">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
